import React from 'react';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import {
  MultiSelectList,
  ListItemData,
} from '../../common/components/multi-select-list/multi-select-list';
import EmeraldDialog from '../../common/components/emerald-dialog/emerald-dialog';
import { ExemptibleTax } from '../interfaces/exemptible-tax.interface';
import { styles } from './multiple-authorities-styles';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { useTranslation } from 'react-i18next';

interface Props {
  taxToBeModified: ExemptibleTax[];
  resolveHandler: (authIds: ListItemData[]) => void;
}

export const showMultipleAuthoritiesModal = async (
  taxToBeModified: ExemptibleTax[],
): Promise<ListItemData[]> => {
  return new Promise(resolve => {
    pushEmeraldModal(
      <MultipleAuthoritiesModal taxToBeModified={taxToBeModified} resolveHandler={resolve} />,
    );
  });
};

export const MultipleAuthoritiesModal: React.FC<Props> = ({
  taxToBeModified,
  resolveHandler,
}: Props): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const onCancel = () => popEmeraldModal();
  const onAccept = (authIds: ListItemData[]) => {
    popEmeraldModal();
    resolveHandler(authIds);
  };

  const selectListProps = {
    onClose: onCancel,
    onConfirm: onAccept,
    message: t('Select_Tax_Authorities_Message'),
    subMessage: t('Select_Tax_Authorities_SubMessage'),
    acceptLabel: t('Next'),
    title: t('HeaderText_TaxExemption'),
    data: taxToBeModified.map((item: ExemptibleTax) => ({ ...item, selected: item.wasExempted })),
  };

  return (
    <EmeraldDialog
      open={true}
      fullWidth={true}
      data-testid='multiple-tax-authorities'
      classes={{
        paper: classes.dialogPaper,
      }}
      onBackdropClick={onCancel}
      onConfirm={onAccept}
    >
      <MultiSelectList {...selectListProps} />
    </EmeraldDialog>
  );
};
